<template>
  <v-window-item value="address">
    <v-card-text>
      <v-card class="bg-white" variant="outlined">
        <v-card-title class="text-subtitle-1">
          <v-icon class="me-1" size="small">mdi-home</v-icon>
          Address Information
        </v-card-title>

        <v-card-text>
          <v-form @submit.prevent="submit">
            <v-card variant="outlined">
              <v-card-title class="text-subtitle-1">
                <v-icon class="me-1" size="small">mdi-home</v-icon>
                Present Address
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="present_village_road_house_flat.value.value"
                      label="Road/House/Flat"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      density="compact"
                      :error-messages="present_village_road_house_flat.errorMessage.value"
                      clearable
                    />
                    <v-text-field
                      v-model="present_post_office.value.value"
                      label="Post Office"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      density="compact"
                      :error-messages="present_post_office.errorMessage.value"
                      clearable
                    />
                    <v-text-field
                      v-model="present_thana_upazilla.value.value"
                      label="Thana/Upazilla"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      density="compact"
                      :error-messages="present_thana_upazilla.errorMessage.value"
                      clearable
                    />
                    <v-text-field
                      v-model="present_district.value.value"
                      label="District"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      density="compact"
                      :error-messages="present_district.errorMessage.value"
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="present_village_house.value.value"
                      label="Village/Area"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      density="compact"
                      :error-messages="present_village_house.errorMessage.value"
                      clearable
                    />
                    <v-text-field
                      v-model="present_post_code.value.value"
                      label="Post Code"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      density="compact"
                      :error-messages="present_post_code.errorMessage.value"
                      clearable
                    />
                    <v-text-field
                      v-model="present_division.value.value"
                      label="Division"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      density="compact"
                      :error-messages="present_division.errorMessage.value"
                      clearable
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card variant="outlined" class="mt-4">
              <v-card-title class="text-subtitle-1">
                <v-icon class="me-1" size="small">mdi-map-marker</v-icon>
                Permanent Address
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="permanent_village_road_house_flat.value.value"
                      label="Road/House/Flat"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      density="compact"
                      :error-messages="permanent_village_road_house_flat.errorMessage.value"
                      clearable
                    />
                    <v-text-field
                      v-model="permanent_post_office.value.value"
                      label="Post Office"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      density="compact"
                      :error-messages="permanent_post_office.errorMessage.value"
                      clearable
                    />
                    <v-text-field
                      v-model="permanent_thana_upazilla.value.value"
                      label="Thana/Upazilla"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      density="compact"
                      :error-messages="permanent_thana_upazilla.errorMessage.value"
                      clearable
                    />
                    <v-text-field
                      v-model="permanent_district.value.value"
                      label="District"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      density="compact"
                      :error-messages="permanent_district.errorMessage.value"
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="permanent_village_house.value.value"
                      label="Village/Area"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      density="compact"
                      :error-messages="permanent_village_house.errorMessage.value"
                      clearable
                    />
                    <v-text-field
                      v-model="permanent_post_code.value.value"
                      label="Post Code"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      density="compact"
                      :error-messages="permanent_post_code.errorMessage.value"
                      clearable
                    />
                    <v-text-field
                      v-model="permanent_division.value.value"
                      label="Division"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      density="compact"
                      :error-messages="permanent_division.errorMessage.value"
                      clearable
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card-actions class="px-0">
              <v-spacer />
              <v-btn
                color="primary"
                type="submit"
                variant="flat"
                :loading="submitting"
              >
                Update
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-window-item>
</template>

<script>
import { useStore } from 'vuex';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { ref } from 'vue';
import { toast } from 'vue3-toastify';

export default {
  props: {
    userAddressInfoData: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    submitting: false
  }),
  watch: {
    userAddressInfoData: {
      handler(data) {
        const address = data?.data || data || {};

        this.present_division.value.value = address.present_division || '';
        this.present_district.value.value = address.present_district || '';
        this.present_thana_upazilla.value.value = address.present_thana_upazilla || '';
        this.present_address.value.value = address.present_address || '';
        this.present_village_house.value.value = address.present_village_house || '';
        this.present_village_road_house_flat.value.value = address.present_village_road_house_flat || '';
        this.present_post_office.value.value = address.present_post_office || '';
        this.present_post_code.value.value = address.present_post_code || '';
        this.permanent_division.value.value = address.permanent_division || '';
        this.permanent_district.value.value = address.permanent_district || '';
        this.permanent_thana_upazilla.value.value = address.permanent_thana_upazilla || '';
        this.permanent_address.value.value = address.permanent_address || '';
        this.permanent_village_house.value.value = address.permanent_village_house || '';
        this.permanent_village_road_house_flat.value.value = address.permanent_village_road_house_flat || '';
        this.permanent_post_office.value.value = address.permanent_post_office || '';
        this.permanent_post_code.value.value = address.permanent_post_code || '';
        this.employee_id.value.value = address.employee_id || '';
        this.address_id.value.value = address.id || null;
      },
      immediate: true,
      deep: true
    }
  },
  setup() {
    const store = useStore();
    const { handleSubmit } = useForm({
      validationSchema: yup.object({
        present_post_code: yup.string().nullable().trim(),
        permanent_post_code: yup.string().nullable().trim()
      })
    });

    const address_id = useField('address_id');
    const employee_id = useField('employee_id');
    const present_division = useField('present_division');
    const present_district = useField('present_district');
    const present_thana_upazilla = useField('present_thana_upazilla');
    const present_address = useField('present_address');
    const present_village_house = useField('present_village_house');
    const present_village_road_house_flat = useField('present_village_road_house_flat');
    const present_post_office = useField('present_post_office');
    const present_post_code = useField('present_post_code');
    const permanent_division = useField('permanent_division');
    const permanent_district = useField('permanent_district');
    const permanent_thana_upazilla = useField('permanent_thana_upazilla');
    const permanent_address = useField('permanent_address');
    const permanent_village_house = useField('permanent_village_house');
    const permanent_village_road_house_flat = useField('permanent_village_road_house_flat');
    const permanent_post_office = useField('permanent_post_office');
    const permanent_post_code = useField('permanent_post_code');

    const submitting = ref(false);

    const submit = handleSubmit(() => {
      submitting.value = true;
      const addressData = {
        id: address_id.value.value,
        present_division: present_division.value.value,
        present_district: present_district.value.value,
        present_thana_upazilla: present_thana_upazilla.value.value,
        present_address: present_address.value.value,
        present_village_house: present_village_house.value.value,
        present_village_road_house_flat: present_village_road_house_flat.value.value,
        present_post_office: present_post_office.value.value,
        present_post_code: present_post_code.value.value,
        permanent_division: permanent_division.value.value,
        permanent_district: permanent_district.value.value,
        permanent_thana_upazilla: permanent_thana_upazilla.value.value,
        permanent_address: permanent_address.value.value,
        permanent_village_house: permanent_village_house.value.value,
        permanent_village_road_house_flat: permanent_village_road_house_flat.value.value,
          permanent_post_office: permanent_post_office.value.value,
        permanent_post_code: permanent_post_code.value.value
      };

      store.dispatch('addressInfo/saveEmployeeAddressInfo', {
        employeeId: employee_id.value.value,
        addressData
      })
        .then((response) => {
          toast.success(response?.message, { timeout: 3000 });
        })
        .catch((error) => {
          toast.error(error.response?.data?.message);
        })
        .finally(() => {
          submitting.value = false;
        });
    });

    return {
      submit,
      address_id,
      employee_id,
      present_division,
      present_district,
      present_thana_upazilla,
      present_address,
      present_village_house,
      present_village_road_house_flat,
      present_post_office,
      present_post_code,
      permanent_division,
      permanent_district,
      permanent_thana_upazilla,
      permanent_address,
      permanent_village_house,
      permanent_village_road_house_flat,
      permanent_post_office,
      permanent_post_code,
      submitting
    };
  }
};
</script>
